import { Component, ChangeDetectorRef } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/index';

@Component({
    templateUrl: './executivesummary.component.html',
    standalone: false
})
export class InstallationExecutiveSummaryPluginComponent {
  public distance: any;
  public config: any;
  public editRoute = ['installation', 'executivesummary', 'edit'];
  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.cdRef.detectChanges();
  }
}

PluginComponent.plugins['installationexecutivesummary'] = InstallationExecutiveSummaryPluginComponent;
